import { AHTeamIconCircle, AHTeamIconCircleSize } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TeamIconCircleComponent_Team$key } from "./__generated__/TeamIconCircleComponent_Team.graphql";

export function TeamIconCircle({
  team,
  size,
}: {
  team: TeamIconCircleComponent_Team$key;
  size?: AHTeamIconCircleSize;
}) {
  const data = useFragment(
    graphql`
      fragment TeamIconCircleComponent_Team on Team {
        color
        icon
        isPrivate
      }
    `,
    team
  );
  return (
    <AHTeamIconCircle
      type={data.icon}
      color={data.color}
      size={size}
      isPrivate={data.isPrivate}
    />
  );
}
